




































































import Vue from 'vue'
import { ProjectDetailHeader } from '@/model/project/ProjectDetailHeader'
import ProgressCircular from '@/components/ProgressCircular.vue'
import BookingAssistant14 from '@/components/project/BookingAssistant/BookingAssistant14.vue'
import BookingAssistant13 from '@/components/project/BookingAssistant/BookingAssistant13.vue'
import BookingAssistant12 from '@/components/project/BookingAssistant/BookingAssistant12.vue'
import BookingAssistant4 from '@/components/project/BookingAssistant/BookingAssistant4.vue'
import BookingAssistant2 from '@/components/project/BookingAssistant/BookingAssistant2.vue'
import BookingAssistant1 from '@/components/project/BookingAssistant/BookingAssistant1.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  BOOKING_ASSISTANT_CANCEL_BOOKING,
  BOOKING_ASSISTANT_FETCH_START_BOOKING_DATA, BOOKING_ASSISTANT_FINISH_BOOKING,
  BOOKING_ASSISTANT_GO_TO_BELEG_STEP,
  BOOKING_ASSISTANT_GO_TO_FIBU_STEP,
  BOOKING_ASSISTANT_GO_TO_MENGEN_STEP, BOOKING_ASSISTANT_GO_TO_PAPIERI_STEP,
  BOOKING_ASSISTANT_GO_TO_POSITIONEN_STEP, BOOKING_ASSISTANT_HAS_FIBU_STEP,
  BOOKING_ASSISTANT_SAVE_BELEG_STEP,
  BOOKING_ASSISTANT_SAVE_FIBU_STEP,
  BOOKING_ASSISTANT_SAVE_MENGEN_STEP
} from '@/store/action-types'
import {
  BelegBookingPayload,
  CancelBookingPayload,
  FibuBookingPayload,
  FinishBookingPayload,
  HasFibuBookingPayload,
  MengenBookingPayload,
  PapieriBookingPayload,
  PositionenBookingPayload,
  SaveBelegStepPayload,
  SaveFibuStepPayload,
  SaveMengenStepPayload,
  StackSelectionPayload,
  StartBookingPayload
} from '@/types/payload'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  BelegBookingResponse,
  FibuBookingResponse,
  HasFibuBookingResponse,
  Konditionen,
  KonditionenLoc,
  KontenErtrag,
  KSTItem,
  KTRItem,
  MengenBookingResponse,
  MitarbeiterBuchnung,
  PapieriBookingResponse,
  PositionenBookingResponse,
  SaveBelegStepResponse,
  SaveFibuStepResponse,
  SaveMengenStepResponse,
  SollHabenItem,
  StartBookingResponse,
  Steuersaetze,
  VersandSpesen,
  Waehrungen,
  ZuschlagRabatt
} from '@/types/service-response'
import { ProjectBookingStart } from '@/model/project/ProjectBookingStart'
import { ProjectBookingPositionen } from '@/model/project/ProjectBookingPositionen'
import { ProjectBookingMengen } from '@/model/project/ProjectBookingMengen'
import { ProjectBookingFibu } from '@/model/project/ProjectBookingFibu'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { ProjectBookingBeleg } from '@/model/project/ProjectBookingBeleg'
import moment from 'moment'
import { ProjectBookingPapieri } from '@/model/project/ProjectBookingPapieri'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  stepper: number
  scrollHeight: string

  stack: number | null
  step1Data: ProjectBookingStart[]
  selectedSchritt: ProjectBookingStart | null
  isCollectiveBooking: boolean
  step2Data: ProjectBookingPositionen[]
  step3Data: ProjectBookingMengen[]
  step4Data: ProjectBookingBeleg | null
  kontoList: KontenErtrag[]
  mitarbeiterList: MitarbeiterBuchnung[]
  versandartList: Konditionen[]
  lieferungList: Konditionen[]
  zahlungList: Konditionen[]
  waehrungList: Waehrungen[]
  steuerList: Steuersaetze[]
  step5Data: ProjectBookingFibu[] | null
  fibuPayload: SaveFibuStepPayload | null
  sollHabenList: SollHabenItem[]
  kstList: KSTItem[]
  ktrList: KTRItem[]
  step6Data: ProjectBookingPapieri[]
}

export default Vue.extend({
  name: 'ProjectBookAssistant',

  components: {
    ProgressCircular,
    BookingAssistant1,
    BookingAssistant2,
    BookingAssistant4,
    BookingAssistant12,
    BookingAssistant13,
    BookingAssistant14
  },

  props: {
    showDialog: Boolean,
    projectId: Number,
    projectDetailHeader: Object as () => ProjectDetailHeader
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      stepper: 1,
      scrollHeight: '',

      stack: null,
      step1Data: [],
      selectedSchritt: null,
      isCollectiveBooking: false,
      step2Data: [],
      step3Data: [],
      step4Data: null,
      kontoList: [],
      mitarbeiterList: [],
      versandartList: [],
      lieferungList: [],
      zahlungList: [],
      waehrungList: [],
      steuerList: [],
      step5Data: null,
      fibuPayload: null,
      sollHabenList: [],
      kstList: [],
      ktrList: [],
      step6Data: []
    }
  },

  watch: {
    stepper (newVal: number): void {
      if(newVal === 6) {
        const finishButton: any = this.$refs['finishButton']
        if(finishButton) {
          finishButton.$el.focus()
        }
      }
    }
  },

  computed: {
    currentUserId (): number | undefined {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isNextStepDisabled (): boolean {
      return this.stepper === 6 || (this.stepper === 2 && this.step2Data.find((item: any) => item.Selektiert) === undefined) || !this.selectedSchritt
    },

    isFinishDisabled (): boolean {
      return this.stepper === 1 || (this.stepper === 2 && this.step2Data.find((item: any) => item.Selektiert) === undefined) || !this.selectedSchritt
    }
  },

  methods: {
    onResize (): void {
      this.scrollHeight = `max-height: calc(100vh - 190px)`
    },

    onBackClick (): void {
      this.moveToStep(1) /*.then(() => {
        this.stepper = this.stepper -1
      })*/
    },

    onForwardClick (): void {
      this.moveToStep(0) /*.then(() => {
        this.stepper = this.stepper + 1
      })*/
    },

    onFinishClick (): void {
      if(this.stepper === 2) {
        this.goToMengenStep(0, true)
      } else {
        this.onFinishBooking()
      }
    },

    onCloseDialog (): void {
      this.onCancelBooking()
      this.$emit('onCloseDialog')
    },

    changeSelectedSchritt (item: ProjectBookingStart): void {
      this.selectedSchritt = item
    },

    changeCollectiveBooking (item: boolean): void {
      this.isCollectiveBooking = item
    },

    async onFinishBooking (): Promise<void> {
      const formularList: string[] = []
      this.step6Data.forEach((item: ProjectBookingPapieri) => {
        if(item.Druckstatus && item.Formular) {
          formularList.push(item.Formular)
        }
      })

      const payload: FinishBookingPayload = {
        Stack: this.stack!,
        Mitarbeiter: this.currentUserId!,
        LanguageId: this.selectedLanguageId,
        AtLastStep: this.stepper === 6 ? true : false,
        FormularList: formularList
      }

      try {
        this.loading = true
        const response: any = await this.$store.dispatch(BOOKING_ASSISTANT_FINISH_BOOKING, payload)
        this.loading = false
        if(!response.IsError) {
          this.$emit('onCloseDialog')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async onCancelBooking (): Promise<void> {
      const payload: CancelBookingPayload = {
        Stack: this.stack!,
        LanguageId: this.selectedLanguageId
      }

      try {
        const response: any = await this.$store.dispatch(BOOKING_ASSISTANT_CANCEL_BOOKING, payload)
        if(!response.IsError) {

        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async moveToStep (direction: number ): Promise<void> {
      if (this.stepper === 1) {
        this.goToPositionenStep(direction)
      } else if (this.stepper === 2) {
        if(direction === 0) {
          this.goToMengenStep(direction, false)
        } else {
          this.fetchData(direction)
        }
      } else if (this.stepper === 3) {
        this.saveMengen(direction)
      } else if (this.stepper === 4) {
        this.saveBeleg(direction)
      } else if (this.stepper === 5) {
        this.saveFibu(direction)
      } else if(this.stepper === 6) {
        if(direction === 1) {
          this.hasFibuStep(direction)
        }
      }
    },

    async goToPositionenStep (direction: number): Promise<void> {
      const payload: PositionenBookingPayload = {
        SchrittID: this.selectedSchritt!.SchrittID,
        CollectiveBooking: this.isCollectiveBooking,
        Stack: this.stack!,
        ProjectId: this.projectId,
        Mitarbeiter: this.currentUserId!,
        LanguageId: this.selectedLanguageId,
      }

      try {
        this.loading = true
        const response: PositionenBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_GO_TO_POSITIONEN_STEP, payload)
        this.loading = false
        if(!response.IsError && response.Items) {
          this.stack = response.Stack
          this.step2Data = ProjectBookingPositionen.createFromResponse(response.Items)
          if(direction === 0) {
            this.stepper = this.stepper + 1
          } else {
            this.stepper = this.stepper - 1
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async goToMengenStep (direction: number, finish: boolean): Promise<void> {
      const stackSelectionPayload: StackSelectionPayload[] = this.step2Data.map((item: ProjectBookingPositionen) => {
        return {ID: item.ID, Selektiert: item.Selektiert}
      })
      const payload: MengenBookingPayload = {
        Selection: stackSelectionPayload,
        Stack: this.stack!,
        LanguageId: this.selectedLanguageId
      }

      try {
        this.loading = true
        const response: MengenBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_GO_TO_MENGEN_STEP, payload)
        this.loading = false
        if(!response.IsError && finish) {
          this.onFinishBooking()
        } else {
          if (!response.IsError && response.Items) {
            this.stack = response.Stack
            this.step3Data = ProjectBookingMengen.createFromResponse(response.Items)
            if (direction === 0) {
              this.stepper = this.stepper + 1
            } else {
              this.stepper = this.stepper - 1
            }
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveMengen (direction: number): Promise<void> {
      const payload: SaveMengenStepPayload = {
        Stack: this.stack!,
        Changes: []
      }

      try {
        this.loading = true
        const response: SaveMengenStepResponse = await this.$store.dispatch(BOOKING_ASSISTANT_SAVE_MENGEN_STEP, payload)
        this.loading = false
        if(!response.IsError && response.Saved) {
          this.stack = response.Stack
          if(direction === 0) {
            this.goToBelegStep(direction)
          } else {
            this.goToPositionenStep(direction)
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async goToBelegStep (direction: number ): Promise<void> {
      const payload: BelegBookingPayload = {
        Stack: this.stack!,
        Mitarbeiter: this.currentUserId!,
        ProjectId: this.projectId,
        LanguageId: this.selectedLanguageId,
        Direction: direction
      }

      try {
        this.loading = true
        const response: BelegBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_GO_TO_BELEG_STEP, payload)
        this.loading = false
        if(!response.IsError && response.Data) {
          this.stack = response.Stack
          this.step4Data = ProjectBookingBeleg.createFromResponse(response.Data)
          this.kontoList = response.Konto
          this.mitarbeiterList = response.Mitarbeiter
          this.versandartList = response.Versandart
          this.lieferungList = response.Lieferung
          this.zahlungList = response.Zahlung
          this.waehrungList = response.Waehrung
          this.steuerList = response.Steuer
          if(direction === 0) {
            this.stepper = this.stepper + 1
          } else {
            this.stepper = this.stepper - 1
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveBeleg (direction: number): Promise<void> {
      //@ts-ignore
      if(this.$refs.step4.dataValidation()) {
        const versandSpesenPayload: VersandSpesen = {
          Adresse: this.step4Data!.VersandSpesen.Adresse,
          AdressID: this.step4Data!.VersandSpesen.AdressID,
          VersandartId: this.step4Data!.VersandSpesen.VersandartId,
          Spesen: this.step4Data!.VersandSpesen.Spesen ? parseInt(this.step4Data!.VersandSpesen.Spesen) : 0,
          VersandKontoId: this.step4Data!.VersandSpesen.VersandKontoId
        }

        const zuschlagRabattPayload: ZuschlagRabatt = {
          Rabatt: this.step4Data!.ZuschlagRabatt.Rabatt ? parseInt(this.step4Data!.ZuschlagRabatt.Rabatt) : 0,
          RabbatKontoId: this.step4Data!.ZuschlagRabatt.RabbatKontoId,
          Zuschlag: this.step4Data!.ZuschlagRabatt.Zuschlag ? parseInt(this.step4Data!.ZuschlagRabatt.Zuschlag) : 0,
          ZuschlagKontoId: this.step4Data!.ZuschlagRabatt.ZuschlagKontoId,
          Versandspesen: this.step4Data!.ZuschlagRabatt.Versandspesen ? parseInt(this.step4Data!.ZuschlagRabatt.Versandspesen) : 0,
        }

        const konditionenPayload: KonditionenLoc = {
          MitarbeiterID: this.step4Data!.Konditionen.MitarbeiterID,
          Datum: this.step4Data!.Konditionen.Datum ? moment(this.step4Data!.Konditionen.Datum).format('YYYY/MM/DD') : '',
          LieferungID: this.step4Data!.Konditionen.LieferungID,
          ZahlungID: this.step4Data!.Konditionen.ZahlungID,
          WaehrungID: this.step4Data!.Konditionen.WaehrungID,
          SteuerID: this.step4Data!.Konditionen.SteuerID,
        }

        const payload: SaveBelegStepPayload = {
          Stack: this.stack!,
          VersandSpesen: versandSpesenPayload,
          ZuschlagRabatt: zuschlagRabattPayload,
          Konditionen: konditionenPayload,
          Kopftext: this.step4Data!.Kopftext,
          Fusstext: this.step4Data!.Fusstext
        }

        try {
          this.loading = true
          const response: SaveBelegStepResponse = await this.$store.dispatch(BOOKING_ASSISTANT_SAVE_BELEG_STEP, payload)
          this.loading = false
          if (!response.IsError && response.Saved) {
            this.stack = response.Stack
            if (direction === 0) {
              this.hasFibuStep(direction)
              //this.goToFibuStep(direction)
            } else {
              this.goToMengenStep(direction, false)
            }
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    async hasFibuStep (direction: number): Promise<void> {
      const payload: HasFibuBookingPayload = {
        Stack: this.stack!
      }

      try {
        this.loading = true
        const response: HasFibuBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_HAS_FIBU_STEP, payload)
        this.loading = false
        if(!response.IsError) {
          if(response.HasFibuStep) {
            this.stack = response.Stack
            this.goToFibuStep(direction)
          } else {
            if(direction === 0) {
              this.stepper = this.stepper + 1
              this.goToPapieriStep(direction)
            } else {
              this.stepper = this.stepper - 1
              this.goToBelegStep(direction)
            }
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async goToFibuStep (direction: number): Promise<void> {
      const payload: FibuBookingPayload = {
        Stack: this.stack!,
        LanguageId: this.selectedLanguageId
      }

      try {
        this.loading = true
        const response: FibuBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_GO_TO_FIBU_STEP, payload)
        this.loading = false
        if(!response.IsError && response.Items) {
          this.stack = response.Stack
          this.step5Data = ProjectBookingFibu.createFromResponse(response.Items)
          this.fibuPayload = {
            Stack: response.Stack,
            SollHaben: response.SollHaben,
            KST: response.KST,
            KTR: response.KTR,
            BuchungenZusammenfassen: response.BuchungenZusammenfassen,
            ProzProjektRabbatVerstreichen: response.ProzProjektRabbatVerstreichen }
          this.sollHabenList = response.SollHabenItems
          this.kstList = response.KSTItems
          this.ktrList = response.KTRItems
          if(direction === 0) {
            this.stepper = this.stepper + 1
          } else {
            this.stepper = this.stepper - 1
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveFibu (direction: number): Promise<void> {
      try {
        this.loading = true
        const response: SaveFibuStepResponse = await this.$store.dispatch(BOOKING_ASSISTANT_SAVE_FIBU_STEP, this.fibuPayload)
        this.loading = false
        if(!response.IsError && response.Saved) {
          this.stack = response.Stack
          if(direction === 0) {
            this.goToPapieriStep(direction)
          } else {
            this.goToBelegStep(direction)
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async goToPapieriStep (direction: number): Promise<void> {
      const payload: PapieriBookingPayload = {
        Stack: this.stack!,
        LanguageId: this.selectedLanguageId
      }

      try {
        this.loading = true
        const response: PapieriBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_GO_TO_PAPIERI_STEP, payload)
        this.loading = false
        if(!response.IsError && response.Items) {
          this.step6Data = ProjectBookingPapieri.createFromResponse(response.Items)
          this.step6Data = this.step6Data.filter((item: any) => item.DruckVisible)
          if(direction === 0) {
            this.stepper = this.stepper + 1
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (direction: number): Promise<void> {
      const payload: StartBookingPayload = {
        Direction: direction,
        Stack: this.stack,
        ProjectId: this.projectId,
        Mitarbeiter: this.currentUserId!,
        LanguageId: this.selectedLanguageId
      }

      try {
        this.loading = true
        const response: StartBookingResponse = await this.$store.dispatch(BOOKING_ASSISTANT_FETCH_START_BOOKING_DATA, payload)
        this.loading = false
        if(!response.IsError && response.Steps) {
          this.stack = response.Stack
          const test = ProjectBookingStart.createFromResponse(response.Steps)
          test.forEach((item: ProjectBookingStart) => {
            this.step1Data.push(item)
            item.Children.forEach((item: ProjectBookingStart) => {
              this.step1Data.push(item)
            })
          })
          if(direction === 1) {
            this.stepper = this.stepper - 1
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
      }
    }
  },

  created (): void {
    this.fetchData(0)
    setTimeout(() => {
      const nextButton: any = this.$refs['nextButton']
      if (nextButton) {
        nextButton.$el.focus()
      }
    })
  }
})
